module.exports = __webpack_public_path__ + "static/media/4.12a8dcc8.png";